import axios from 'axios';
import qs from 'qs';
import { Toast } from 'vant';
// import {
// 	setCookie,
// 	getCookie,
// 	delCookie
// } from '@/utils/cookie.js';

// Vue.use(Message)
// Vue.use(Loading)
// import i18n from '../i18n/i18n.js';
// let lans = localStorage.getItem('ZBlang');
// let languages = lans ? lans : 'CN';
// let languages = 'CN';
// let i18nMessage = i18n.messages[languages].message;

// import {
// 	Encrypt,
// 	Decrypt
// } from "./aes.js"

axios.defaults.timeout = 15000;
// let ser = sessionStorage.getItem('RegionServer');//数据不在本区，替换域名
// var baseUrl = ser?'https://' + ser +'/' :'https://global.hdlcontrol.com/HangZhouHdlCloudApi/Contractors/';
// var baseUrl = "https://www.cctc.cc/"; //公共接口

//判断URL是否需要添加根路径
var fliterUrl = function (url) {
	if (url.startsWith('http')) {
		return url;
	}
	return url;
};

//错误提示封装
function ModalError(contents) {
	Toast(contents);
}

// function loginout() {
// 	store.state.portrait = false;
// 	delCookie('token');
// 	delCookie('guid');
// 	sessionStorage.clear();
// 	router.push('/');
// }

//1请求拦截器
axios.interceptors.request.use(
	config => {
		// config.headers = {
		// 	'Content-Type': 'application/json;charse=UTF-8',
		// }
		// if (getCookie('token')) {
		// 	config.headers.Authorization = getCookie('token');
		// }
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

//2响应拦截器即异常处理
axios.interceptors.response.use(
	response => {
		if (response.status == 200 || response.status == 304) {
			//处理共有的操作
			// switch (response.data.code) {
			// 	case 'UserNameOrPasswordError':
			// 		// Message.error('账号或密码错误！');
			// 		break;
			// }
			// if (response.data.code !== 200 && response.data.code !== undefined) {
			// 	Message(response.data.message);
			// }
		}

		return response.data;
	},
	error => {
		if (error && error.response) {
			switch (error.response.status) {
				case 400:
					ModalError(error.response.status + ',错误请求');
					break;
				case 401:
					ModalError(error.response.status + ',未授权，请重新登录');
					break;
				case 403:
					ModalError(error.response.status + ',拒绝访问');
					break;
				case 404:
					ModalError(error.response.status + ',请求错误，未找到该资源');
					break;
				case 405:
					ModalError(error.response.status + ',请求方法未允许');
					break;
				case 408:
					ModalError(error.response.status + ',请求超时');
					break;
				case 500:
					ModalError(error.response.status + ',服务器端出错');
					break;
				case 501:
					ModalError(
						error.response.status + ',网络未实现,服务端不支持该数据请求方法'
					); //服务端不理解或者不支持客户端发给的http方法()
					break;
				case 502:
					ModalError(error.response.status + ',网络错误');
					break;
				case 503:
					ModalError(error.response.status + ',服务不可用');
					break;
				case 504:
					ModalError(error.response.status + ',网络超时');
					break;
				case 505:
					ModalError(error.response.status + ',http版本不支持该请求'); //http版本不支持该请求
					break;
				default:
					ModalError('连接错误' + `${error.response.status}`); //连接错误
			}
		} else {
			// console.log('网络连接失败，断网')
			ModalError('网络连接失败，请检测网络'); //连接到服务器失败,网络连接失败，断网
		}
		// Message.error(err.message)
		return Promise.resolve(error.response);
	}
);

//请求开启loading防止重复而报错
let needLoadingRequestCount = 0;

function showFullScreenLoading() {
	//开loading
	if (needLoadingRequestCount === 0) {
		//通过修改vuex的mutations方法从而改变store状态isGlobalSpin变量去控制loading的开关
		// store.commit('changeGlobalSpin', true);
		Toast.loading({
			forbidClick: true,
			duration: 0
		});
	}
	needLoadingRequestCount++;
}

function tryHideFullScreenLoading() {
	//关loading
	if (needLoadingRequestCount <= 0) {
		return false;
	}
	needLoadingRequestCount--;
	if (needLoadingRequestCount === 0) {
		// store.commit('changeGlobalSpin', false);
		// Loading.service();

		Toast.clear();
	}
}

let http = {
	get: (url, opt = {}) => {
		if (opt.loading) {
			showFullScreenLoading();
		}
		return new Promise((resolve, reject) => {
			axios
				.get(fliterUrl(url), opt)
				.then(response => {
					resolve(response);
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {
					opt.loading && tryHideFullScreenLoading();
				});
		});
	},
	post: opt => {
		showFullScreenLoading();

		// let token = getCookie('token');

		// let tokenPORT = [ //不需token的接口集合
		// 	'/api/Login'
		// ];
		var config = {
			method: 'POST',
			// data: formData
			data: qs.stringify(opt.params),
			headers: {
				// 'Content-Type': 'application/json;charse=UTF-8',
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		};
		if (opt.responseType) {
			config.responseType = 'arraybuffer';
		}
		// if (tokenPORT.indexOf(opt.url) == -1) { //为true时，说明需要token
		// if (token === undefined || token === '') { //如果token为空，提示并返回登陆页面
		// 	router.push('/');
		// 	ModalError('请登录获取令牌后再进入系统');
		// } else {

		// config.headers["Authorization"] = getCookie('token');
		// }
		// }

		// 2，获取当前运行环境状态
		let RuntimeEnvironment = process.env.NODE_ENV; //运行环境分为 development （开发环境）、production （生成环境）

		var urls;
		let re = /^\/api\//; //正则匹配是否开头有api
		// console.log(RuntimeEnvironment)
		if (RuntimeEnvironment === 'development') {
			//开发环境
			if (opt.url.indexOf('/api/') > -1 && re.test(opt.url)) {
				urls = opt.url;
			} else if (opt.url.indexOf('http') > -1) {
				urls = opt.url;
			} else {
				alert('请添加代理请求前缀 ‘/api/’');
			}
		} else {
			// 部署上线前，需要替换掉‘/api’,以及后面的补充路径 ‘panelApplets/WechatApplets/’
			if (opt.url.indexOf('/api/') > -1) {
				//不使用nginx
				// let texturl = opt.url.replace('/api/', '');
				// urls = fliterUrl(texturl);
				//nginx
				urls = opt.url;
			}
		}
		config.url = urls;

		return new Promise((reslove, reject) => {
			axios(config)
				.then(response => {
					if (response.status === 200) {
						tryHideFullScreenLoading();
					}
					reslove(response);
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {
					tryHideFullScreenLoading();
				});
		});
	}
};

export default http;
